import type { GatsbyBrowser } from "gatsby";

let isHistoryNavigation = false;

export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  window.addEventListener("popstate", () => {
    isHistoryNavigation = true;
  });
};

export const shouldUpdateScroll: GatsbyBrowser["shouldUpdateScroll"] = () => {
  if (isHistoryNavigation) {
    isHistoryNavigation = false;
    return false;
  }

  return true;
};
